import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import TextField from 'material-ui/TextField';
import actions from '../state/actions';
import globalEvents from '../events';
import { localize, t } from '../i18n';

// @TODO: file size cannot be bigger than 25 MB or (25 * 1024 * 1024)
class AddAttachment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileList: [],
      description: null,
    };
    this.attachmentInput = null;

    this.messageHandler = () =>
      this.processCloseOverride();
  }

  componentWillMount() {
    globalEvents.on('messages.close-override', this.messageHandler);
  }

  componentWillUnmount() {
    globalEvents.off('messages.close-override');
  }

  processCloseOverride() {
    this.props.refreshWorkorderComments();
  }

  handleChangeAttachments(fileList) {
    let finalFileList = this.state.fileList;
    finalFileList = finalFileList.concat(fileList);
    this.setState({
      fileList: finalFileList,
    }, () => {
      if (this.props.onSelectAttachments) {
        this.props.onSelectAttachments(fileList);
      }
      this.attachmentInput.value = null;
    });
  }

  handleChangeDescription(evt, value) {
    this.setState({
      description: value,
    }, () => {
      if (this.props.onChangeDescription) {
        this.props.onChangeDescription(evt, value);
      }
    });
  }

  render() {
    const {
      fileList,
      description,
    } = this.state;
    const {
      attachmentsOverride,
      blockNativeOverride,
      allowMultiple,
      addDescription,
      addFile,
      hintText,
      className,
    } = this.props;
    let descriptionInput = null;
    const wrapperClasses = [];
    const submitButtonDisabled = description === null;

    if (addDescription === true) {
      let attachmentsList = addFile ? (
        <span>{this.props.t('No attachments selected')}.</span>
      ) : null;
      if (fileList.length > 0) {
        if (fileList.length < 5) {
          attachmentsList = (
            <span>{fileList.map(file => file.name).join(', ')}</span>
          );
        } else {
          attachmentsList = (
            <span>{this.props.t('{fileListLength} attachments selected', { fileListLength: fileList.length })}</span>
          );
        }
      }

      const inputProps = {
        ref: (fileInput) => {
          this.attachmentInput = fileInput;
        },
        type: 'file',
        style: {
          opacity: 0,
          height: '100%',
          width: '100%',
          position: 'relative',
        },
        onChange: (evt) => {
          evt.preventDefault();
          const changeFileList = [];
          Object.keys(this.attachmentInput.files).forEach((fileKey) => {
            const file = this.attachmentInput.files[fileKey];
            if (file) {
              file.preview = window.URL.createObjectURL(file);
            }
            changeFileList.push(file);
          });
          this.handleChangeAttachments(changeFileList);
          return false;
        },
      };

      if (allowMultiple === true) {
        inputProps.multiple = true;
      }

      const fileInput = addFile ? (<div className="md-fab md-fab-accent">
        <i className="material-icons">&#xE226;</i>
        {React.createElement('input', inputProps)}
      </div>) : null;

      descriptionInput = [
        <div key="add-attachment" className="md-fab-wrapper md-fab-wrapper-left add-attachment">
          {fileInput}
        </div>,
        <div key="description-input" className="description-input">
          <div className="uk-grid">
            <div className="uk-width-small-8-10 uk-width-mobile-7-10">
              <TextField
                name={`attachment-${Math.random()}`}
                value={description || ''}
                hintStyle={{ fontSize: 14 }}
                fullWidth
                hintText={this.props.t(hintText)}
                onChange={evt => this.handleChangeDescription(evt, evt.target.value)}
              />
            </div>
            <div className="uk-width-small-2-10 uk-width-mobile-3-10 attachment-controls">
              <a
                href="#reset-attachments"
                onClick={() => {
                  if (submitButtonDisabled === false) {
                    this.setState({
                      fileList: [],
                      description: null,
                    });
                  }
                }}
              >
                <i className={`md-icon material-icons ${(submitButtonDisabled === true) ? 'md-icon-muted' : 'md-icon-danger'}`}>&#xE14C;</i>
              </a>
              <a
                href="#add-attachments"
                onClick={() => {
                  if (submitButtonDisabled === false) {
                    if (this.props.onAddAttachments) {
                      this.props.onAddAttachments(Object.assign({}, this.state));
                    }
                    this.setState({
                      fileList: [],
                      description: null,
                    });
                  }
                }}
              >
                <i className={`md-icon material-icons ${(submitButtonDisabled === true) ? 'md-icon-muted' : 'md-icon-primary'}`}>&#xE148;</i>
              </a>
            </div>
          </div>
          <div className="uk-text-italic uk-text-small uk-text-muted">
            {attachmentsList}
          </div>
        </div>,
      ];
    }

    if (className) {
      wrapperClasses.push(className);
    }

    if (attachmentsOverride === true && !blockNativeOverride) {
      descriptionInput = (
        <div className="uk-text-right">
          <button type="button" className="md-btn md-btn-primary" onClick={() => this.props.openAddCommentAttachment()}>{this.props.t('Add comment')}</button>
        </div>
      );
    }

    return (
      <div id="add-attachment-container" className={wrapperClasses.join(' ')}>
        {descriptionInput}
      </div>
    );
  }
}

AddAttachment.propTypes = {
  className: PropTypes.string,
  hintText: PropTypes.string,
  allowMultiple: PropTypes.bool,
  addDescription: PropTypes.bool,
  addFile: PropTypes.bool,
  blockNativeOverride: PropTypes.bool,
  onChangeDescription: PropTypes.func,
  onSelectAttachments: PropTypes.func,
  onAddAttachments: PropTypes.func,
  attachmentsOverride: PropTypes.bool,
  openAddCommentAttachment: PropTypes.func,
  refreshWorkorderComments: PropTypes.func,
  // eslint-disable-next-line
  itemId: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

AddAttachment.defaultProps = {
  hintText: t('Description'),
  allowMultiple: false,
  addDescription: true,
};

const mapStateToProps = state => ({
  attachmentsOverride: state.attachments.override,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  openAddCommentAttachment() {
    dispatch(actions.openAddCommentAttachment(ownProps.itemId));
  },
  refreshWorkorderComments() {
    dispatch(actions.retrieveWorkorderComments(ownProps.itemId));
  },
});

export default localize(connect(mapStateToProps, mapDispatchToProps)(AddAttachment));



// WEBPACK FOOTER //
// ./src/containers/AddAttachment.js